import { Filter } from "@api/models/HttpClientModels";

export default class RestaurantOfferFilter extends Filter {
    restaurantId?: string;
    foodName?: string;
    foodCategoryIds?: string;
    hasActiveUserFoodPriceRuleSetting?: boolean
}